import { useLazyQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFields } from "../../Utils/AllPagesQuriesAndMutations";
import { useGetPageData } from "./useGetPageData";
import { ErrorToast } from "../Components/ToastComponent/RectHotToast";

const useFetchTableData = (
  query: Function,
  fetchdata: Function,
  setIsLoading?: Function,
  Key?: string,
  triggerLRList?: boolean,
  // shouldFetch: boolean = true
) => {

  const abortRef = useRef<AbortController>(new AbortController());
  const { fields } = useGetPageData();
  const [triggeredByRefetch, setTriggeredByRefetch] = useState(false);

  const [TableHeaders, setFieldsToShowInTableHeaders] = useState([]);
  let data;


  let key = Key || "";

  const [getCurrentField, { loading }] = useLazyQuery(getFields, {
    fetchPolicy: "network-only",
    onError: (err) => {
      // console.log("end");
      ErrorToast(`Failed to fetch the Fields `);
      setIsLoading?.(false);
    },
  });
  // Redux state selector for refetching requirement
  let Refetch = useSelector((store: any) => store?.FormFieldData.refresh);

  // State to trigger a workaround for updates
  const [Workaround, setWorkAround] = useState(false);

  // Redux state selector for user rights data
  const rights = useSelector((state: any) => state.userRightsReducer.userRightsData);

  // Current path to determine the relevant rights
  const path = window.location.pathname;
  const dispatch = useDispatch();

  //run once on mount  create controller; on unmount-> abort
  useEffect(() => {
    return () => {
      abortRef.current.abort();
    }
  }, [])

  useEffect(() => {
    if (Refetch || !(data && Object.values(data)?.length) || !fields?.length) {
      if (Refetch) {
        setTriggeredByRefetch(Refetch);
      }
      // getCurrentField({
      //   variables: { Table_Key: Key },
      // }).then((res) => {
      setWorkAround(!Workaround);
      // });

      dispatch({ type: "Refetch", payload: false });
    }

  }, [Refetch, rights, getCurrentField, dispatch, key]);

  useEffect(() => {


    console.log(query, "%%", fetchdata, "%%", setIsLoading, "%%", Key)
    // if (fieldData) {


    getCurrentField({
      variables: { Table_Key: Key },
    }).then(({ data: fieldData }) => {
      var fields = fieldData?.GetUserTableColumnManagementWithUserId_Page_ID.filter((item: any) => item.Status).map(
        (item: any) => item?.Field_Name
      );
      console.log(fieldData?.GetUserTableColumnManagementWithUserId_Page_ID)
      const fieldsToShowInTableHeadersData = fieldData?.GetUserTableColumnManagementWithUserId_Page_ID.filter(
        (item: any) => {
          return item.Status
        }
      ).map((item: any) => [item?.Field_Name, item?.Table_Column_Name, item?.Column_Total ? item?.Field_Name : null, item?.Table_View]);
      setFieldsToShowInTableHeaders(fieldsToShowInTableHeadersData);

      var key = rights[path]?.Page_Id;
      console.log(fieldsToShowInTableHeadersData, "fieldsfieldsfieldsfields");
      dispatch({ type: "SET_ORIGINAL_FIELDS", payload: fields });
      dispatch({ type: "SET_ORIGINAL_PAGE_KEY", payload: key });
      // If fields are available, construct the query and fetch data
      // console.log(fields, "fieldsfieldss2");
      if (fields?.length > 0) {
        console.log("For Query", fields)
        fetchdata({
          query: query(fields, triggeredByRefetch),
          fetchPolicy: "network-only",
          //this is option to control the api call while it is unmounting we need to cancel the api call

          // context: {
          //   fetchOptions: { signal: abortRef.current.signal },
          // }

        });
        if (triggeredByRefetch) {
          // setTriggeredByRefetch(false);
        }
        // setWorkAround(false);
      }
    })
  }, [fetchdata, Workaround, query, dispatch, rights, triggerLRList]);

  // Effect to handle data refetch based on user rights and column configuration


  return { loading, TableHeaders: TableHeaders };
};

export default useFetchTableData;
